import React from "react";
import Pageslayout from "../../Layouts/Pageslayout";
import PageIntro from "../../components/PageIntro";
const Index = ({ title, description }) => {
  return (
    <Pageslayout
      pageintro={true}
      title="Find Top Real Estate Agents in Pakistan
    "
      description="We have partnered with various real estate agents who will be
    available to assist and guide you on different locations and
    projects for sale and rent. Please stay tuned for further updates."
    >
      {/* <PageIntro /> */}
    </Pageslayout>
  );
};

export default Index;
